module.exports = {"pt-BR":{"modal":{"buttons":{"close":"Fechar","confirm":"Confirmar"}}}}